import React from 'react';

import styles from './badgeStyles';

import Icon from 'buyside/components/presentation/Icon/icon';
import TooltipWhite from 'buyside/components/presentation/Tooltips/TooltipWhite/tooltipWhite';

import AceAnalystIcon from 'SVGs/badges/ace_analyst';
import CriticIcon from 'SVGs/badges/critic';
import FlavorOfWeekIcon from 'SVGs/badges/flavor_of_week';
import FundIcon from 'SVGs/badges/fund';
import GrandChampionIcon from 'SVGs/badges/grand_champion';
import InfluencerIcon from 'SVGs/badges/influencer';
import MasterAnalystIcon from 'SVGs/badges/master_analyst';
import PaladinIcon from 'SVGs/badges/paladin';
import RankedIcon from 'SVGs/badges/ranked';
import TopRankedIcon from 'SVGs/badges/top_ranked';

import { formatDate } from 'buyside/util/dateHelper';

export const badgeIconMapping = {
  1: RankedIcon,
  2: TopRankedIcon,
  3: CriticIcon,
  4: InfluencerIcon,
  5: PaladinIcon,
  6: FundIcon,
  7: FlavorOfWeekIcon,
  8: GrandChampionIcon,
  9: MasterAnalystIcon,
  10: AceAnalystIcon
};

const Badge = ({ badgeInfo, showExtendedInfo, badgeClass }) => {
  const badgeIcon = badgeIconMapping[badgeInfo.badge.id];

  const renderDescription = () => {
    const badgeDescription = badgeInfo.badge.description;
    const badgeName = badgeInfo.badge.name;
    return (
      <div className={styles.badgeDescription}>
        <Icon type={badgeIcon} style={styles.largeBadgeIcon} />
        <div className={styles.badgeText}>
          <h5>{badgeName}</h5>
          <p>{badgeDescription}</p>
        </div>
      </div>
    );
  };

  const badgeNumber = badgeInfo.badgeNumber;
  const badgeClassDisplay = badgeClass || styles.badge;

  return (
    <figure className={badgeClassDisplay}>
      <TooltipWhite
        overlay={renderDescription()}
        placement="top"
        mouseLeaveDelay={0}
        mouseEnterDelay={0.1}
      >
        <div data-testid={`badge-tooltip-${badgeInfo.badge.id}`}>
          <Icon type={badgeIcon} />
        </div>
      </TooltipWhite>
      {!showExtendedInfo && <div className={styles.badgeNumber}>{badgeNumber}</div>}
      {showExtendedInfo && (
        <div>
          <h5 className={styles.extendedInfoBadgeName}>{badgeInfo.badge.name}</h5>
          {badgeNumber > 1 && (
            <div className={styles.extendedInfoEarned}>
              Earned: <strong>{badgeNumber}X</strong>
            </div>
          )}
          <div className={styles.extendedInfoEarned}>
            Last Earned: <strong>{formatDate(badgeInfo.earnedAt)}</strong>
          </div>
        </div>
      )}
    </figure>
  );
};

export default Badge;
